import debug from "debug";

// override the log level in localStorage.debug
const baseLogger = debug("fe-occ-work-sched");

const logger = {
  trace: baseLogger.extend("trace"),
  debug: baseLogger.extend("debug"),
  info: baseLogger.extend("info"),
  warn: baseLogger.extend("warn"),
  error: baseLogger.extend("error"),
};

export default logger;
